import Article from "./Article"
import Lecture from "./Lecture"
import Podcast from "./Podcast"
import Research from "./Research"

export default {
  Article,
  Podcast,
  Lecture,
  Research
}
